export default "__VITE_ASSET__DP_QEK3q__"